import {Component} from '@angular/core'

/**
 * @deprecated use error toast, or design system component (which?) instead
 */
@Component({
  selector: 'bgo-error-banner',
  templateUrl: './error-banner.component.html',
  standalone: true,
})
export class ErrorBannerComponent {}
